import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { proxyEvent } from '@util/angular.utils';
import { selectOptionById } from '@util/input-utils';
import { isNonEmptyArray, unsub } from '@util/utils';
import { Subscription } from 'rxjs';

function trySelectById(id: any, entries: any, formControl: UntypedFormControl) {
  if (Array.isArray(entries)) {
    const entry = entries.find((e: any) => {
      return e.id === id;
    });
    if (entry && formControl.value !== entry) {
      formControl.setValue(entry);
    }
  }
}

function addEventProxy<T = any>(fc: UntypedFormControl, eventEmitter: EventEmitter<T>) {
  return fc.valueChanges.subscribe((evt: any) => {
    proxyEvent(evt, eventEmitter);
  });
}

@Component({
  selector: 'app-image-scale-tray',
  templateUrl: './image-scale-tray.component.html'
})
export class ImageScaleTrayComponent implements OnInit {

  resolutionFC = new UntypedFormControl();

  typeFC = new UntypedFormControl();

  selectById = selectOptionById;

  _resolutions: any = [
    {
      id: 1,
      name: 'Originalgröße'
    }
  ];

  @Input() set resolutions(res: any) {
    if (isNonEmptyArray(res)) {
      this._resolutions = res;
      //this.hasResolutions = isNonEmptyArray(res);
    }
  }
  hasResolutions = true;

  _resId = 1;
  @Input('selected-res-id') set selectedResolution(res: any) {
    this._resId = res;
    trySelectById(res, this._resolutions, this.resolutionFC);
  }

  _types: any = [
    {
      id: 1,
      name: 'Original (png)',
    }
  ];

  @Input() set types(types: any) {
    if (isNonEmptyArray(types)) {
      this._types = types;
      //this.hasTypes = true;
    }
  }
  hasTypes = true;

  _typeId = 1;
  @Input('selected-type-id') set selectedType(t: any) {
    this._typeId = t;
    trySelectById(t, this._types, this.typeFC);
  }

  _noRow = false;
  @Input('no-row') set noRow(nr: any) {
    this._noRow = nr;
  }

  @Output('res-change') resChange = new EventEmitter<any>();
  @Output('type-change') typeChange = new EventEmitter<any>();

  private resSub!: Subscription;
  private typeSub!: Subscription;

  constructor() {
    this.resolutionFC.setValue(this._resolutions[0]);
    this.typeFC.setValue(this._types[0]);
  }

  ngOnInit(): void {
    this.resSub = addEventProxy(this.resolutionFC, this.resChange);
    this.typeSub = addEventProxy(this.typeFC, this.typeChange);
  }

  ngOnDestroy(): void {
    this.resSub = unsub(this.resSub);
    this.typeSub = unsub(this.typeSub);
  }
}
